import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import { TCompany } from './types';

type CompaniesResponse = {
  companies: TCompany[];
  nextCursor?: string;
  total: number;
};

type UseCompaniesPaginatedOptions = {
  pylonAccountID?: string;
  cursor?: string;
  limit?: number;
  enabled?: boolean;
};

const buildCompaniesQueryString = (
  options: UseCompaniesPaginatedOptions
): string | null => {
  const { pylonAccountID, limit = 25, enabled = true, cursor } = options;

  if (!enabled) return null;

  const params = new URLSearchParams();
  if (limit) params.set('paginationConfig[limit]', String(limit));
  if (cursor) params.set('paginationConfig[cursor]', cursor);
  if (pylonAccountID)
    params.set('filterConfig[pylonAccountID]', String(pylonAccountID));

  const qs = params.toString();

  return qs ? `company?${qs}` : 'company';
};

export const useCompaniesPaginated = (options: UseCompaniesPaginatedOptions) => {
  const key = buildCompaniesQueryString(options);

  const { data, error, mutate, isLoading, isValidating } =
    useSWR<CompaniesResponse>(
      key,
      key
        ? SWRFetcher(
            {
              method: 'GET',
            },
            undefined
          )
        : null
    );

  return {
    data,
    error,
    mutate,
    isLoading: !!isLoading,
    isValidating: !!isValidating,
  };
};


